import { FC, useMemo } from 'react'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { EscalaList } from '../../core/_models'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { montaColunasEscalaEmpresa } from './columns/_columns'

type Props = {
  empresa: number
}

export const EscalaEmpresaTable: FC<Props> = ({ empresa }) => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const columns = useMemo(() => montaColunasEscalaEmpresa(empresa), [empresa])

  return (
    <CustomTable<EscalaList>
      id='kt_table_escala_empresa'
      ariaLabel='Escalas cadastradas da instituição'
      itemLabel={{ singular: 'escala', plural: 'escalas' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title='Nenhuma escala cadastrada'
          description='Use “Nova escala” para montar a agenda dos profissionais desta instituição.'
        />
      }
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
